import { useContext, useMemo } from 'react';

import { useHouseholdQuery } from '../../generated/graphql';
import { splitHouseholds } from '../../helpers/households';
import { TrackingContext, TrackingProps } from '../../TrackingContext';
import { useGuestMessagingExperiment } from '../../hooks/experiment/useGuestMessagingExperiment';

const EVENTS_WITH_EXPERIMENT_DATA = new Set([
  'Messaging Hub Displayed',
  'Website Share Initiated',
  'Website Shared',
  'Guest Messaging Interaction',
]);

const useShareTracking = () => {
  const { track: baseTrack } = useContext(TrackingContext);
  const { data: householdsData } = useHouseholdQuery();
  const { loading: _experimentLoading, ...experimentTrackingData } = useGuestMessagingExperiment();

  const householdCount = useMemo(() => householdsData?.households.length, [householdsData]);
  const contactableHouseholdEmailCount = useMemo(
    () => splitHouseholds('email', householdsData?.households).contactable.length,
    [householdsData]
  );
  const contactableHouseholdSMSCount = useMemo(
    () => splitHouseholds('phone', householdsData?.households).contactable.length,
    [householdsData]
  );

  const track = (event: string, trackingData?: TrackingProps<any>) => {
    const eventExperimentTrackingData = EVENTS_WITH_EXPERIMENT_DATA.has(event) ? experimentTrackingData : {};

    baseTrack(event, {
      householdCount: householdCount,
      contactableHouseholdEmailCount,
      contactableHouseholdSMSCount,
      ...eventExperimentTrackingData,
      ...trackingData,
    });
  };

  return track;
};

export default useShareTracking;
